import React, { useMemo } from 'react';

import Breadcrumbs from '@/components/Base/Breadcrumbs';
import { usePageProps, useSeoMeta } from '@/hooks';
import { useGetBreadcrumbsQuery } from '@/queries';
import { geProductUrl, getMainPageUrl, getOrganizationUrl } from '@/utils';

export function PageBreadcrumbs() {
  const pageProps = usePageProps();
  const {
    params,
    intl: { locale, formatMessage },
    location: { pathname },
  } = pageProps;
  const { pageTitle } = useSeoMeta({ pageProps });
  const { data: breadcrumbsListApi } = useGetBreadcrumbsQuery({
    locale,
    pathname,
  });

  const breadcrumbs = useMemo(() => {
    const apiList = breadcrumbsListApi?.links || [];

    if (!apiList?.length) {
      return [
        {
          name: formatMessage({ id: 'breadcrumbs.mainPage' }),
          link: getMainPageUrl(),
        },
        ...(params.companySlug && !params.skuSlug
          ? [
              {
                name: pageTitle,
                link: getOrganizationUrl(params.companySlug),
              },
            ]
          : []),
        ...(params.companySlug && params.skuSlug && params.productId
          ? [
              {
                name: pageTitle,
                link: geProductUrl({
                  org: params.companySlug,
                  slug: params.skuSlug,
                  id: params.productId,
                }),
              },
            ]
          : []),
      ];
    }

    return apiList;
  }, [params, breadcrumbsListApi?.links]);

  return breadcrumbs?.length ? <Breadcrumbs breadcrumbs={breadcrumbs} /> : null;
}

export default PageBreadcrumbs;
